/*
 * @Description:
 * @Author: shenkaiyao
 * @Date: 2020-12-10 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-23 14:14:58
 */
import Dispatch from './dispatch';

export default Dispatch